import types from '../mutation-types';
import ComplianceReportsAPI from '../../api/complianceReports';

export const state = {
  records: [],
  meta: {
    thresholdMinutes: 10,
    totalCount: 0,
    exceedingCount: 0,
  },
  uiFlags: {
    isFetching: false,
    isDownloading: false,
  },
};

export const getters = {
  getAll(_state) {
    return _state.records;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getExceedingThreshold(_state) {
    return _state.records.filter(r => r.exceeds_threshold);
  },
};

export const actions = {
  get: async function getReports({ commit }) {
    commit(types.SET_COMPLIANCE_REPORTS_UI_FLAG, { isFetching: true });
    try {
      const response = await ComplianceReportsAPI.get();
      const { payload, meta } = response.data;

      commit(types.SET_COMPLIANCE_REPORTS, payload);
      commit(types.SET_COMPLIANCE_REPORTS_META, meta);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_COMPLIANCE_REPORTS_UI_FLAG, { isFetching: false });
    }
  },

  download: async function downloadReport({ commit }) {
    commit(types.SET_COMPLIANCE_REPORTS_UI_FLAG, { isDownloading: true });
    try {
      const response = await ComplianceReportsAPI.download();
      const blob = new Blob([response.data], {
        type: 'text/csv;charset=utf-8;',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      const fileName = `compliance_report_${new Date().toISOString().slice(0, 10)}.csv`;

      link.setAttribute('download', fileName);
      link.setAttribute('href', url);
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_COMPLIANCE_REPORTS_UI_FLAG, { isDownloading: false });
    }
  },

  downloadHistory: async function downloadHistory({ commit }) {
    commit(types.SET_COMPLIANCE_REPORTS_UI_FLAG, { isDownloading: true });
    try {
      const response = await ComplianceReportsAPI.downloadHistory();
      const blob = new Blob([response.data], {
        type: 'text/csv;charset=utf-8;',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      const fileName = `compliance_history_${new Date().toISOString().slice(0, 10)}.csv`;

      link.setAttribute('download', fileName);
      link.setAttribute('href', url);
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_COMPLIANCE_REPORTS_UI_FLAG, { isDownloading: false });
    }
  },
};

export const mutations = {
  [types.SET_COMPLIANCE_REPORTS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_COMPLIANCE_REPORTS](_state, data) {
    _state.records = data;
  },

  [types.SET_COMPLIANCE_REPORTS_META](
    _state,
    {
      threshold_minutes: thresholdMinutes,
      total_count: totalCount,
      exceeding_count: exceedingCount,
    }
  ) {
    _state.meta = {
      thresholdMinutes,
      totalCount,
      exceedingCount,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
